"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTeamTheme = void 0;
const styles_1 = require("@mui/material/styles");
function createPalette(mode) {
    return {
        mode,
        common: {
            black: '#07070c',
            white: '#fff',
        },
        primary: {
            main: '#c9fb00',
            //   light: '#71cc52',
            //   dark: '#1e8c0d',
        },
        secondary: {
            main: '#ff5c5f',
            contrastText: '#fff',
            light: '#ff9c9d',
        },
        text: {
            primary: '#333',
            secondary: '#2c2c2e',
            disabled: '#777778',
            // hint: '#57575a',
        },
        success: {
            main: '#168208',
            light: '#e5f7e1',
            contrastText: '#fff',
        },
        info: {
            main: '#5fb6fe',
            light: '#9dd2fe',
            contrastText: '#2c2c2e',
        },
        warning: {
            main: '#feb26c',
            light: '#fecb9d',
            contrastText: '#2c2c2e',
        },
        error: {
            main: '#db353d',
            light: '#e9afad',
            contrastText: '#fff',
            dark: '#bc0b0e',
        },
        divider: '#ebebed',
    };
}
function createTeamTheme({ name, mode }) {
    const themeOptions = {
        name,
        palette: createPalette(mode),
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        color: '#333',
                        fontSize: 16,
                        fontWeight: 'bold',
                        textTransform: 'none',
                        lineHeight: '20px',
                        padding: '12px 24px',
                        borderRadius: 200,
                    },
                    text: {
                        padding: '12px',
                        borderBottom: '4px solid transparent',
                        borderRadius: 0,
                        '&:hover': {
                            backgroundColor: 'transparent',
                            borderColor: '#c9fb00',
                        },
                    },
                    outlined: {
                        lineHeight: '18px',
                        borderColor: '#07070c',
                        color: '#07070c',
                        '&:hover': {
                            borderColor: '#07070c',
                        },
                    },
                    contained: {
                        color: '#07070c',
                        boxShadow: 'none',
                        ':hover': {
                            boxShadow: 'none',
                        },
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    colorDefault: {
                        backgroundColor: '#fff',
                        boxShadow: `0 1px 2px 0 rgb(0 0 0 / 20%), 0 1px 3px 0 rgb(0 0 0 / 10%)`,
                    },
                },
            },
            MuiAvatar: {
            // colorDefault: {
            //   backgroundColor: '#32a31a !important',
            // },
            },
            MuiBadge: {
            // colorSecondary: {
            //   backgroundColor: '#71cc52',
            // },
            },
            MuiTabs: {
                styleOverrides: {
                    indicator: {
                        backgroundColor: '#2c2c2e',
                    },
                },
            },
            MuiCardHeader: {
            // root: {
            //   backgroundColor: '#fafafc !important',
            // },
            },
            MuiToolbar: {
                styleOverrides: {
                    root: {
                        paddingLeft: '0 !important',
                        paddingRight: '0 !important',
                    },
                },
            },
            MuiStepConnector: {
                styleOverrides: {
                    line: {
                        borderLeft: 0,
                    },
                },
            },
            MuiStepContent: {
                styleOverrides: {
                    root: {
                        borderLeft: 0,
                    },
                },
            },
            MuiStepLabel: {
                styleOverrides: {
                    root: {
                        padding: '4px 0',
                        // alignItems: 'flex-start', // TODO: try to align to the baseline and compensate padding
                    },
                    label: {
                        fontSize: '22px',
                        marginLeft: '16px',
                    },
                },
            },
            MuiStepIcon: {
                styleOverrides: {
                    root: {
                        marginTop: '3px',
                    },
                    text: {
                        fontWeight: 'bold',
                    },
                },
            },
        },
        typography: {
            fontFamily: '"Aktiv Grotesk", "Helvetica", "Arial", sans-serif',
            h1: {
                fontSize: '52px',
                fontWeight: 700,
                lineHeight: '56px',
                letterSpacing: '-2.08px',
            },
            h2: {
                fontSize: '42px',
                fontWeight: 700,
                lineHeight: '46px',
                letterSpacing: '-2.08px',
            },
            h3: {
                color: '#06ac47',
                fontSize: '32px',
                fontWeight: 700,
                lineHeight: '36px',
                letterSpacing: '-2.08px',
            },
            h4: {
                fontSize: '22px',
                fontWeight: 700,
                lineHeight: '26px',
                letterSpacing: '-1.08px',
            },
            h5: {
                fontSize: '20px',
                fontWeight: 700,
                lineHeight: '24px',
                letterSpacing: '-1.08px',
            },
            h6: {
                fontSize: '18px',
                fontWeight: 700,
                lineHeight: '22px',
                letterSpacing: '-1.08px',
            },
            body1: {
                fontFamily: '"Aktiv Grotesk", "Helvetica", "Arial", sans-serif',
                fontSize: '16px',
                lineHeight: '20px',
            },
        },
    };
    return (0, styles_1.createTheme)(themeOptions);
}
exports.createTeamTheme = createTeamTheme;
//# sourceMappingURL=team.js.map